import { takeEvery, put, call } from 'redux-saga/effects';
import { mkQcsSyncResourcesPayload } from 'data/qcsSyncResourceTypes';
import { getSpendingWatchListsSuccess } from 'data/spendingWatchList/actions';
import { transformResponseToSpendingWatchLists } from 'data/spendingWatchList/transformers';

import { send } from './webSocketQCSInstance';
import * as actions from './webSocketQCSActions';

export function* sendWebSocketQCSMessageActionWatcher() {
  yield takeEvery(actions.sendWebSocketQCSMessage, function* _sendWebSocketQCSMessage(action) {
    send(JSON.stringify(action.payload));
  });
}

const messageProxy = Object.freeze({
  'SWL_ASYNC_DUMP': function* proxy(action) {
    yield put(getSpendingWatchListsSuccess(mkQcsSyncResourcesPayload({
      resources: transformResponseToSpendingWatchLists(action.payload),
      lastSyncDate: action.payload.data?.metaData?.asOf,
    })));
  },
});

export function* getWebSocketQCSMessageActionWatcher() {
  yield takeEvery(actions.getWebSocketQCSMessage, function* _getWebSocketQCSMessage(action) {
    const proxy = messageProxy[action.payload.eventType];
    yield call(proxy, action);
  });
}

export default [
  sendWebSocketQCSMessageActionWatcher,
  getWebSocketQCSMessageActionWatcher,
];
